import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Configuration } from '../app.constants';

@Injectable()
export class RestService {
    public modelName: string;
    public modelClass: any;
    private headers: HttpHeaders;

    private is_looking_for_all: Subject<any[]> = null;
    private emptyObject: any = null;

    //cache data
    public last_getAll: Array<any>;

    constructor(private _http: HttpClient, private _configuration: Configuration) {
        this.modelName = "to-configure";

        this.headers = new HttpHeaders({
          'Content-Type':  'application/json',
          'Accept': 'application/json'
        });
    }

    // ***** HELPERS
    public getAllFromLS(maxtime: number = 0): Array<any>{
      let json = localStorage.getItem("rest_all_"+this.modelName);
      if(json){
        let obj = JSON.parse(json);
        if(obj && (obj.date < (Date.now() - maxtime)) ){
          return obj;
        }
      }
    }

    public getEmptyObject(){
      if(!this.emptyObject){
        this.emptyObject = new this.modelClass();
      }
      return this.emptyObject;
    }


    public getFromCache(id): any{
      let obs = new Subject();
      //on definie que faire avec les data
      let traitement = (res) => {
        let data = this.last_getAll.find((unit) => unit.id === id);
        obs.next(data);
      };
      //puis on determine d'où on va prendre ses données

      //si on a les données en cache
      if(this.last_getAll){
        console.log('récupération des données en cache');
        traitement(true);
      }
      //si on a pas encore les data
      else{
        //et si je suis le premier a les demanders
        if(!this.is_looking_for_all){
          console.log('on est le premier a demander les datas');
          this.getAll().subscribe(traitement);
        }
        //si, une requete est deja en cours, on s'inscris dessus
        else{
          console.log('une requete est deja en cours');
          this.is_looking_for_all.subscribe(traitement);
        }
      }
      return obs;
    }

    private getActionUrl(){
      return this._configuration.ServerWithApiUrl + this.modelName + '/';
    }

    //transformation du format indexé, au format associatif
    private recordsToObject(responseInJson){
      //recuperation du tableau portant le nom de la collection
      let data = responseInJson[this.modelName];
      //transformation du format indexé, au format associatif
      let tab = data.records.map((elem)=>{
        let unit = {};
        //on se base sur le numéro des columns et l'ordre pour reconstruire l'objet
        data.columns.forEach((champ,index) => {
          unit[champ] = elem[index];
        });
        return new this.modelClass(unit);
      });
      return tab;
    }


    // **** REST functions
    public getAll(): Observable<any[]>{
        //on crée un nouveau subject (pour faire du hot to cold)
        this.is_looking_for_all = new Subject<any[]>();
        //on fais l'appel http une fois, puis on transmet le resultat à tout le monde
        this._http.get(this.getActionUrl()).subscribe((response:  HttpResponse<any>) => {
          //transformation du format indexé, au format associatif
          let tab = this.recordsToObject(response);
          this.last_getAll = tab;
          let obj = {
            date: Date.now(),
            data: tab
          };
          this.is_looking_for_all.next(tab);
          this.is_looking_for_all = null;
          localStorage.setItem("rest_all_"+this.modelName,JSON.stringify(obj));
          return tab;
        });
      return this.is_looking_for_all;
    }

    public get(id: number): Observable<any>{
        return this._http.get(this.getActionUrl() + id)
        .pipe(
            map((response:  HttpResponse<any>) => {
              let obj = new this.modelClass( response );
              return obj;
            }),
            catchError(this.handleError)
        );
    }

    //recuperation uniquement du nombre de resultats
    public count(param=""): Observable<any>{
      return this._http.get(this.getActionUrl()+"?order=id&page=1,0&"+param).pipe(
        map((response:  HttpResponse<any>) => {
          let data = response[this.modelName];
          return data.results;
        }),
        catchError(this.handleError)
      );
    }

    public search(champ:string, valeur:any, matchType:string = "eq"): Observable<any>{
        return this._http.get(this.getActionUrl() + '?filter='+champ+','+matchType+','+valeur)
        .pipe(
            map((response:  HttpResponse<any>) => {
              return this.recordsToObject(response);
            }),
            catchError(this.handleError)
        );
    }

    public add(item: any): Observable<any>{
        let toAdd = JSON.stringify(item);

        return this._http.post(this.getActionUrl(), toAdd, { headers: this.headers })
        .pipe(
            catchError(this.handleError)
        );
    }

    public addAll(tab: Array<any>): Observable<any>{
      let toAdd = JSON.stringify(tab);
      console.log("ajout de ",toAdd)
      return this._http.post(this.getActionUrl(), toAdd, { headers: this.headers })
      .pipe(
        catchError(this.handleError)
      );
    }

    public update(id: number, itemToUpdate: any): Observable<any>{
        return this._http.put(this.getActionUrl() + id, JSON.stringify(itemToUpdate), { headers: this.headers })
        .pipe(
            catchError(this.handleError)
        );
    }

    public delete(id: number): Observable< any >{
        return this._http.delete(this.getActionUrl() + id)
        .pipe(
          catchError(this.handleError)
        );
    }

    private handleError(error:  HttpResponse<any>) {
        console.error(error);
        return throwError(error);
    }
}
